<div class="calendar-box container box-content">
    <input type="hidden" name="date" #dateInput/>
    <div class="calendar-header">
        <div *ngIf="!allowSelectMonthYear">
            <span class="month-label">{{ MONTH_NAMES[month] }}</span>
            <span class="year-label"> {{ year }}</span>
        </div>
        <div *ngIf="allowSelectMonthYear">
            <div class="calendar-dropdown-wrapper month-selector">
                <button class="calendar-dropdown-button" (click)="openMonthSelector()">
                    {{MONTH_NAMES[month]}}
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10L12 15L17 10" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <div class="calendar-dropdown-scroller" *ngIf="monthSelectorBackdrop">
                    <div class="calendar-dropdown-item" *ngFor="let monthName of MONTH_NAMES;let i = index"
                         [ngClass]="{'selected': monthName === MONTH_NAMES[month]}"
                         (click)="month = i;populateDays();monthSelectorBackdrop = false" >
                        {{ monthName }}
                    </div>
                </div>

                <div class="calendar-dropdown-backdrop" *ngIf="monthSelectorBackdrop" (click)="monthSelectorBackdrop = false"></div>
            </div>
            <div class="calendar-dropdown-wrapper year-selector">
                <button class="calendar-dropdown-button" (click)="openYearSelector()">
                    {{year}}
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10L12 15L17 10" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <div class="calendar-dropdown-scroller" *ngIf="yearSelectorBackdrop">
                    <div class="calendar-dropdown-item" *ngFor="let y of YEARS"
                         [ngClass]="{'selected': y === year}"
                         (click)="year = y;populateDays();yearSelectorBackdrop = false" >
                        {{ y }}
                    </div>
                </div>

                <div class="calendar-dropdown-backdrop" *ngIf="yearSelectorBackdrop" (click)="yearSelectorBackdrop = false"></div>
            </div>
        </div>
        <div class="month-nav">
            <button
                    type="button"
                    class="previous-month"
                    (click)="decreaseMon(); populateDays();">
                <svg fill="none"
                     viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="2" d="M15 19l-7-7 7-7"/>
                </svg>
            </button>
            <button type="button"
                    class="next-month"
                    (click)="increaseMon(); populateDays()">
                <svg
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 5l7 7-7 7"
                    />
                </svg>
            </button>
        </div>
    </div>
    <!-- End of header -->

    <!-- Days of week -->
    <div class="day-of-week">
        <div *ngFor="let day of DAYS; index as key"
             class="day-label">
            {{ day }}
        </div>
    </div>
    <!-- end day of week -->

    <div class="days-wrapper">
        <div *ngFor="let bd of blankDays"
             class="day-blank-slot">
        </div>
        <div *ngFor="let item of displayDays; index as dateIndex" class="day-slot">
            <span (click)="!item.disabled && getDateValue(item.date)" 
                  [ngClass]="{
                 'is-today': isToday(item.date),
                 'text-gray-700': !isToday(item.date),
                 'selected': isSelectedDate(item.date),
                 'disabled': item.disabled
             }">{{ item.date }}</span>
        </div>

        <div *ngFor="let rd of restDays"
             class="day-blank-slot">
        </div>
    </div>
</div>